import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Normalize a trading symbol for cross-system matching.
 * Mirrors backend/src/utils/symbolNormalize.js
 *
 * Strips slashes, uppercases, and converts USDT/USDC → USD
 * (Alpaca only supports USD-denominated crypto pairs).
 *
 *   "AVAX/USDT" → "AVAXUSD"
 *   "BTC/USD"   → "BTCUSD"
 *   "AAPL"      → "AAPL"
 */
export function normalizeSymbol(s) {
  if (!s) return '';
  return s.replace(/\//g, '').toUpperCase().replace(/(USDT|USDC)$/, 'USD');
}
